(function(){
  "use strict";

  if (window.__PO_K5_ISQUN_TRILANG_20260305__) return;
  window.__PO_K5_ISQUN_TRILANG_20260305__ = true;

  var STORAGE_KEY = "po_k5_isqun_lang";
  var DEFAULT_LANG = "FR";
  var ROOT_SEL = '.po-axis-section[data-po-lex-id="isqun"]';

  var URLS = {
    lexicon: "https://goodyart.store/pages/lexique-simplifie/",
    isqun: "https://goodyart.store/pages/isqun",
    threnisqun: "https://goodyart.store/pages/threnisqun",
    enneagone: "https://goodyart.store/pages/enneagone-regulateur",
    equiphase: "https://goodyart.store/pages/sceau-d-equiphase",
    syntonie: "https://goodyart.store/pages/sceau-de-syntonie",
    aisthisi: "https://goodyart.store/pages/sceau-d-aisthisi",
    aneporon: "https://goodyart.store/pages/sceau-d-aneporon",
    ife: "https://goodyart.store/pages/sceau-d-ife",
    ayeemi: "https://goodyart.store/pages/sceau-d-ayeemi",
    oroyuyay: "https://goodyart.store/pages/sceau-d-oroyuyay",
    yuyarina: "https://goodyart.store/pages/sceau-de-yuyarina",
    oendomare: "https://goodyart.store/pages/sceau-d-oendomare",
    katuvys: "https://goodyart.store/pages/katuvys",
    title: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/L_Isqun_copie.png?v=1772883682",
    katuvys_img: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535",
    freq492: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_492.png?v=1773413365",
    enneagone_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Enneagone_copie.png?v=1772894801",
    enneagone_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Enneagonne_regulateur_fonctionnel.png?v=1773289356",
    freq145: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_145.png?v=1773413772",
    equiphase_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_equiphase_2.png?v=1772895117",
    equiphase_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Equiphase.png?v=1772895310",
    freq619: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_619.png?v=1773414281",
    syntonie_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_de_Syntonie_593_2.png?v=1772896047",
    syntonie_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_de_Syntonie_593_2_copie_2.png?v=1772896520",
    freq593: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_593.png?v=1773448635",
    aisthisi_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2.png?v=1772896688",
    aisthisi_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aisthisi_720_2_copie.png?v=1772897503",
    freq720: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_720.png?v=1773448446",
    aneporon_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aneporon_1303_2.png?v=1772897595",
    aneporon_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aneporon_1303_2_copie.png?v=1772897936",
    freq1303: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_1303.png?v=1773448851",
    ife_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_2.png?v=1772899462",
    ife_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_If_161_3_copie.png?v=1772899631",
    freq161: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_161.png?v=1773449115",
    ayeemi_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_2.png?v=1772902150",
    ayeemi_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Aye_mi_111_3_copie_2.png?v=1772902473",
    freq111: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_111.png?v=1773449250",
    oroyuyay_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_r_yuyay_210_2.png?v=1772903151",
    oroyuyay_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_r_yuyay_210_2_copie.png?v=1772903307",
    freq210: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_210.png?v=1773449350",
    yuyarina_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_2.png?v=1772905412",
    yuyarina_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_Yuyarina_286_3_copie_2.png?v=1772905496",
    freq286: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_286.png?v=1773449437",
    oendomare_concept: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_2.png?v=1772906456",
    oendomare_function: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Sceau_d_Oendomare_421_3_copie_2.png?v=1772906531",
    freq421: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_421.png?v=1773449520"
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }
  function normLang(v){
    var s = clampStr(v).toUpperCase().trim();
    return (s === "FR" || s === "EN" || s === "ES") ? s : DEFAULT_LANG;
  }
  function readLang(){
    try { return normLang(localStorage.getItem(STORAGE_KEY)); }
    catch(e){ return DEFAULT_LANG; }
  }
  function storeLang(lang){
    try { localStorage.setItem(STORAGE_KEY, normLang(lang)); } catch(e){}
  }
  function canon(txt){
    return '<span class="notranslate" translate="no">' + clampStr(txt) + '</span>';
  }
  function qs(root, sel){ try { return root.querySelector(sel); } catch(e){ return null; } }
  function qsa(root, sel){ try { return Array.prototype.slice.call(root.querySelectorAll(sel)); } catch(e){ return []; } }

  var TERMS = {
    isqun: canon("Isqun"),
    katuvys: canon("La Katûvýs"),
    threnisqun: canon("Threnisqun"),
    enneagone: canon("Ennéagone régulateur"),
    equiphase: canon("Sceau d’Équiphase"),
    syntonie: canon("Sceau de Syntonie"),
    aisthisi: canon("Sceau d’Aísthisi"),
    aneporon: canon("Sceau d’Anépôron"),
    ife: canon("Sceau d’Ifẹ̀"),
    ayeemi: canon("Sceau d’Ayeẹmí"),
    oroyuyay: canon("Sceau d’Ọ̀rọ̀yuyay"),
    yuyarina: canon("Sceau de Yuyarina"),
    oendomare: canon("Sceau d’Œndomare"),
    katupirsia5: canon("Katûpirsia 5 – La Matrice-substrat")
  };

  var AUDIO_UI = {
    FR: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    EN: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    ES: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang)] || AUDIO_UI.FR;
  }

  var SCEAUX = [
    { key: "equiphase", name: "Sceau d’Équiphase", freq: "619", href: URLS.equiphase, concept: URLS.equiphase_concept, function: URLS.equiphase_function, guide: URLS.freq619,
      fr: "Régulation du temps cyclique et désintégration spiralée des décalages temporels.",
      en: "Regulates cyclical time and performs the spiral disintegration of temporal shifts.",
      es: "Regula el tiempo cíclico y desintegra en espiral los desajustes temporales." },
    { key: "syntonie", name: "Sceau de Syntonie", freq: "593", href: URLS.syntonie, concept: URLS.syntonie_concept, function: URLS.syntonie_function, guide: URLS.freq593,
      fr: "Réajustement des déphasages internes et syntonie différée des polarités actives et réceptives.",
      en: "Readjusts internal phase shifts and restores delayed syntony between active and receptive polarities.",
      es: "Reajusta los desfases internos y restituye la sintonía diferida entre polaridades activas y receptivas." },
    { key: "aisthisi", name: "Sceau d’Aísthisi", freq: "720", href: URLS.aisthisi, concept: URLS.aisthisi_concept, function: URLS.aisthisi_function, guide: URLS.freq720,
      fr: "Régulation des intensités sensorielles et des saturations synesthésiques.",
      en: "Regulates sensory intensities and synesthetic saturations.",
      es: "Regula las intensidades sensoriales y las saturaciones sinestésicas." },
    { key: "aneporon", name: "Sceau d’Anépôron", freq: "1303", href: URLS.aneporon, concept: URLS.aneporon_concept, function: URLS.aneporon_function, guide: URLS.freq1303,
      fr: "Contenance des effondrements entropiques et déliaison des paradoxes de l’infini.",
      en: "Contains entropic collapses and loosens the paradoxes of infinity.",
      es: "Contiene los colapsos entrópicos y desata las paradojas del infinito." },
    { key: "ife", name: "Sceau d’Ifẹ̀", freq: "161", href: URLS.ife, concept: URLS.ife_concept, function: URLS.ife_function, guide: URLS.freq161,
      fr: "Stabilisation des débordements affectifs et recentrage du lien.",
      en: "Stabilizes affective overflow and recenters the bond.",
      es: "Estabiliza los desbordamientos afectivos y recentra el vínculo." },
    { key: "ayeemi", name: "Sceau d’Ayeẹmí", freq: "111", href: URLS.ayeemi, concept: URLS.ayeemi_concept, function: URLS.ayeemi_function, guide: URLS.freq111,
      fr: "Transmutation des mémoires atemporelles et intégration des lignées vibratoires.",
      en: "Transmutes atemporal memories and integrates vibratory lineages.",
      es: "Transmuta memorias atemporales e integra los linajes vibratorios." },
    { key: "oroyuyay", name: "Sceau d’Ọ̀rọ̀yuyay", freq: "210", href: URLS.oroyuyay, concept: URLS.oroyuyay_concept, function: URLS.oroyuyay_function, guide: URLS.freq210,
      fr: "Dissolution des saturations mentales et discursives, retour au silence fertile.",
      en: "Dissolves mental and discursive saturations and returns toward fertile silence.",
      es: "Disuelve las saturaciones mentales y discursivas y devuelve al silencio fértil." },
    { key: "yuyarina", name: "Sceau de Yuyarina", freq: "286", href: URLS.yuyarina, concept: URLS.yuyarina_concept, function: URLS.yuyarina_function, guide: URLS.freq286,
      fr: "Recomposition des formes émergentes et restitution de la plasticité créatrice.",
      en: "Recomposes emerging forms and restores creative plasticity.",
      es: "Recompone las formas emergentes y restituye la plasticidad creadora." },
    { key: "oendomare", name: "Sceau d’Œndomare", freq: "421", href: URLS.oendomare, concept: URLS.oendomare_concept, function: URLS.oendomare_function, guide: URLS.freq421,
      fr: "Reconnexion aux pulsations originelles et rappel de la résonance primordiale.",
      en: "Reconnects with original pulsations and recalls primordial resonance.",
      es: "Reconecta con las pulsaciones originarias y recuerda la resonancia primordial." }
  ];

  function setSlotText(root, slot, value){
    var node = qs(root, '[data-po-slot="' + slot + '"]');
    if (node) node.textContent = clampStr(value);
  }
  function setSlotHTML(root, slot, value){
    var node = qs(root, '[data-po-slot="' + slot + '"]');
    if (node) node.innerHTML = clampStr(value);
  }
  function setImage(root, slot, url, alt){
    var node = qs(root, '[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.src = clampStr(url || "");
    node.alt = clampStr(alt || "");
  }
  function renderListInto(root, slot, items){
    var node = qs(root, '[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.innerHTML = "";
    (items || []).forEach(function(item){
      var li = document.createElement("li");
      li.innerHTML = item;
      node.appendChild(li);
    });
  }
  function renderWordBlocks(root, slot, blocks){
    var node = qs(root, '[data-po-slot="' + slot + '"]');
    if (!node) return;
    node.innerHTML = "";
    (blocks || []).forEach(function(block){
      var wrap = document.createElement("div");
      wrap.className = "po-axis-wb";
      wrap.innerHTML = '<div class="po-axis-wb__h">' + clampStr(block.head) + '</div>' +
                       '<div class="po-axis-wb__t">' + clampStr(block.text) + '</div>';
      node.appendChild(wrap);
    });
  }

  function buildMetaCard(title, mediaUrl, text, href){
    var media = mediaUrl
      ? '<span class="po-isqun-meta__media" aria-hidden="true"><img class="po-isqun-meta__img" src="' + clampStr(mediaUrl) + '" alt="" loading="lazy" decoding="async" /></span>'
      : "";
    var textHtml = href
      ? '<a class="po-isqun-meta__textlink" href="' + clampStr(href) + '">' + clampStr(text) + '</a>'
      : '<span class="po-isqun-meta__text">' + clampStr(text) + '</span>';
    return '<div class="po-isqun-meta__item"><span class="po-isqun-meta__title">' + clampStr(title) + '</span>' + media + textHtml + '</div>';
  }

  function buildSealMedia(item){
    return (
      '<div class="po-sceau-card__mediawrap">' +
        '<span class="po-sceau-card__media" aria-hidden="true"><img class="po-sceau-card__img" src="' + clampStr(item.concept) + '" alt="" loading="lazy" decoding="async" /></span>' +
        '<span class="po-sceau-card__media" aria-hidden="true"><img class="po-sceau-card__img" src="' + clampStr(item.function) + '" alt="" loading="lazy" decoding="async" /></span>' +
        '<span class="po-sceau-card__media po-sceau-card__media--guide" aria-hidden="true"><img class="po-sceau-card__img" src="' + clampStr(item.guide) + '" alt="" loading="lazy" decoding="async" /></span>' +
      '</div>'
    );
  }

  function buildConfigurationCard(lang){
    var copy = {
      FR: {
        title: "Configuration opérative",
        desc: TERMS.enneagone + " est la structure opérative interne à " + TERMS.isqun + ", apparaissant lorsque les neuf Sceaux de cette bande vibratoire entrent en action simultanée et en syntonie complète.",
        button: "Voir la page"
      },
      EN: {
        title: "Operative configuration",
        desc: TERMS.enneagone + " is the operative structure internal to " + TERMS.isqun + ", appearing when the nine Seals of this vibratory band enter simultaneous action and complete syntony.",
        button: "Open page"
      },
      ES: {
        title: "Configuración operativa",
        desc: TERMS.enneagone + " es la estructura operativa interna a " + TERMS.isqun + ", que aparece cuando los nueve Sellos de esta banda vibratoria entran en acción simultánea y en sintonía completa.",
        button: "Ver la página"
      }
    }[lang];

    return (
      '<article class="po-config-card">' +
        '<a class="po-config-card__title" href="' + URLS.enneagone + '">' + TERMS.enneagone + '</a>' +
        '<div class="po-config-card__mediawrap">' +
          '<div class="po-config-card__media"><img class="po-config-card__img" src="' + URLS.enneagone_concept + '" alt="" loading="lazy" decoding="async" /></div>' +
          '<div class="po-config-card__media"><img class="po-config-card__img" src="' + URLS.enneagone_function + '" alt="" loading="lazy" decoding="async" /></div>' +
          '<div class="po-config-card__media po-config-card__media--guide"><img class="po-config-card__img" src="' + URLS.freq145 + '" alt="" loading="lazy" decoding="async" /></div>' +
        '</div>' +
        '<div class="po-config-card__label">' + clampStr(copy.title) + '</div>' +
        '<p class="po-config-card__desc">' + copy.desc + '</p>' +
        '<div class="po-config-card__linkline"><a href="' + URLS.enneagone + '">' + clampStr(copy.button) + '</a></div>' +
      '</article>'
    );
  }

  function buildSealCards(lang){
    var button = { FR: "Voir la page", EN: "Open page", ES: "Ver la página" }[lang];
    return SCEAUX.map(function(item){
      return (
        '<article class="po-sceau-card">' +
          '<a class="po-sceau-card__title" href="' + item.href + '">' + canon(item.name) + '</a>' +
          buildSealMedia(item) +
          '<div class="po-sceau-card__freq"># ' + clampStr(item.freq) + '</div>' +
          '<p class="po-sceau-card__desc">' + clampStr(item[lang.toLowerCase()]) + '</p>' +
          '<div class="po-sceau-card__linkline"><a href="' + item.href + '">' + clampStr(button) + '</a></div>' +
        '</article>'
      );
    }).join("");
  }

  function content(lang){
    if (lang === "EN") {
      return {
        title: "Isqun",
        kicker: 'Excerpt from <em>' + TERMS.katupirsia5 + '</em><br />(Band of potential frequencies and wave-bearing regulator of nine poles)',
        h_def: "Operative definition",
        meta_html:
          buildMetaCard("Element", URLS.katuvys_img, TERMS.katuvys, URLS.katuvys) +
          buildMetaCard("Alignment frequency", URLS.freq492, "492 Hz") +
          buildMetaCard("Operative structure", URLS.enneagone_concept, TERMS.enneagone, URLS.enneagone),
        def_short: TERMS.isqun + ' designates the band of potential frequencies in which the nine regulating Seals reside; their simultaneous action within this same band makes the ' + TERMS.enneagone + ' appear as its operative structure.',
        def_long:
          '<p>' + TERMS.isqun + ' is neither a decorative figure nor a simple field. It is a regulator of frequencies that orders the geometry of the field without imposing it, maintains the balance of the posœnnoïal breath, and creates the conditions of a stable ' + canon('RéZonans') + '.</p>' +
          '<p>Within this band, the nine Seals exist, vibrate and interact. Their simultaneous activation does not create an external body placed beside ' + TERMS.isqun + ': it makes appear an internal operative configuration, ' + TERMS.enneagone + ', which remains an integral part of the isqunian band.</p>' +
          '<p>When the interaction between the Seals reaches a critical intensity, the excess does not leave ' + TERMS.katuvys + '. It changes state: from frequencies it becomes operative densities and condenses into ' + TERMS.threnisqun + '. The same alignment wave — 492 — ensures continuity between origin and expression.</p>',
        h_config: "Operative configuration",
        config_html: buildConfigurationCard(lang),
        h_sceaux: "The nine regulating Seals",
        sceaux_html: buildSealCards(lang),
        h_features: "Operative dynamics",
        features: [
          TERMS.isqun + ' names the structural plane that readjusts without conscious call.',
          'It orders the field without imposing it and makes possible a stable vibratory coherence.',
          'Its nine poles act as regulators of time, phase shift, perception, entropy, affects, memory, discourse, emergence and origin.',
          TERMS.enneagone + ' appears only when the nine Seals enter simultaneous action and complete syntony inside ' + TERMS.isqun + '.',
          TERMS.threnisqun + ' receives the condensed operative residues produced by the intense interaction of the Seals.'
        ],
        h_questions: "Applications / markers",
        questions: [
          'Does the situation call for silent structural rebalancing, or for a localized ritual action?',
          'Which Seal best matches the observed excess: time, phase shift, sensorium, infinity, affects, memory, discourse, form, or origin?',
          'Is the issue still at the band level (' + TERMS.isqun + ') or already at the condensed-response level (' + TERMS.threnisqun + ')?',
          'Are the tensions being dissolved, or simply accorded into a livable geometry?'
        ],
        example_title: "Ex.",
        example: 'When a field saturates without yet requiring an explicit rite, ' + TERMS.isqun + ' remains the correct name. When the excess becomes situated and requires a precise activation, the operation passes toward ' + TERMS.threnisqun + '.',
        h_family: "Systemic links",
        family_1: '<p><strong>With ' + TERMS.katuvys + ':</strong> ' + TERMS.isqun + ' is one of the internal potential bands of the matrix-substrate. It remains katûvýsian in nature and participates in the expansion of the world through regulation rather than domination.</p>',
        family_2: '<p><strong>With ' + TERMS.threnisqun + ' and ' + TERMS.enneagone + ':</strong> 492 is their common alignment wave. ' + TERMS.isqun + ' is the frequency of origin, ' + TERMS.threnisqun + ' the frequency of experience, and ' + TERMS.enneagone + ' the operative structure internal to ' + TERMS.isqun + ' when the nine Seals act simultaneously.</p>',
        h_wordbuild: "Construction of the term",
        word_blocks: [
          { head: "1) isqun", text: "Quechua root meaning “nine”: the term carries the logic of a nine-centered vibratory coherence." },
          { head: "2) –isqun", text: "Canonical suffix used for base-nine organizations such as " + canon("Katûvýsqun") + " and " + TERMS.threnisqun + "." },
          { head: "3) Operative value", text: "The word names a band of potential frequencies whose role is cyclical balancing and the silent preparation of regulation." }
        ],
        word_notes: [
          'Status: epicene, invariable canonical entry.',
          'Element: ' + TERMS.katuvys + '.',
          'Alignment frequency shared with ' + TERMS.threnisqun + ': 492.',
          TERMS.enneagone + ' is the operative structure internal to ' + TERMS.isqun + ', not an external or autonomous system.'
        ],
        cta_translate: "Suggest a translation of the concept"
      };
    }

    if (lang === "ES") {
      return {
        title: "Isqun",
        kicker: 'Extracto de <em>' + TERMS.katupirsia5 + '</em><br />(Banda de frecuencias potenciales y estructura de onda portadora de regulación a nueve polos)',
        h_def: "Definición operativa",
        meta_html:
          buildMetaCard("Elemento", URLS.katuvys_img, TERMS.katuvys, URLS.katuvys) +
          buildMetaCard("Frecuencia de alineación", URLS.freq492, "492 Hz") +
          buildMetaCard("Estructura operativa", URLS.enneagone_concept, TERMS.enneagone, URLS.enneagone),
        def_short: TERMS.isqun + ' designa la banda de frecuencias potenciales en la que residen los nueve Sellos reguladores; su acción simultánea dentro de esta misma banda hace aparecer el ' + TERMS.enneagone + ' como su estructura operativa.',
        def_long:
          '<p>' + TERMS.isqun + ' no es una figura decorativa ni un simple campo. Es un regulador de frecuencias que ordena la geometría del campo sin imponerla, mantiene el equilibrio del soplo posœnnoïal y crea las condiciones de una ' + canon('RéZonans') + ' estable.</p>' +
          '<p>Dentro de esta banda, los nueve Sellos existen, vibran e interactúan. Su activación simultánea no crea un cuerpo exterior colocado junto a ' + TERMS.isqun + ': hace aparecer una configuración operativa interna, ' + TERMS.enneagone + ', que sigue siendo parte integrante de la banda isquniana.</p>' +
          '<p>Cuando la interacción entre los Sellos alcanza una intensidad crítica, el excedente no abandona ' + TERMS.katuvys + '. Cambia de estado: de frecuencias pasa a densidades operativas y se condensa en ' + TERMS.threnisqun + '. La misma onda de alineación —492— asegura la continuidad entre origen y expresión.</p>',
        h_config: "Configuración operativa",
        config_html: buildConfigurationCard(lang),
        h_sceaux: "Los nueve Sellos reguladores",
        sceaux_html: buildSealCards(lang),
        h_features: "Dinámicas operativas",
        features: [
          TERMS.isqun + ' nombra el plano estructural que reajusta sin llamada consciente.',
          'Ordena el campo sin imponerlo y hace posible una coherencia vibratoria estable.',
          'Sus nueve polos actúan como reguladores del tiempo, del desfase, de la percepción, de la entropía, de los afectos, de la memoria, del discurso, de la emergencia y del origen.',
          TERMS.enneagone + ' aparece sólo cuando los nueve Sellos entran en acción simultánea y en sintonía completa dentro de ' + TERMS.isqun + '.',
          TERMS.threnisqun + ' recibe los residuos operativos condensados producidos por la interacción intensa de los Sellos.'
        ],
        h_questions: "Aplicaciones / referencias",
        questions: [
          '¿La situación pide un reequilibrio estructural silencioso, o una acción ritual localizada?',
          '¿Qué Sello corresponde mejor al exceso observado: tiempo, desfase, sensorialidad, infinito, afectos, memoria, discurso, forma u origen?',
          '¿El problema sigue en el plano de banda (' + TERMS.isqun + ') o ya en el plano de respuesta condensada (' + TERMS.threnisqun + ')?',
          '¿Las tensiones se disuelven, o sólo se acuerdan en una geometría vivible?'
        ],
        example_title: "Ej.",
        example: 'Cuando un campo se satura sin exigir todavía un rito explícito, ' + TERMS.isqun + ' sigue siendo el nombre justo. Cuando el exceso se vuelve situado y exige una activación precisa, la operación pasa hacia ' + TERMS.threnisqun + '.',
        h_family: "Vínculos sistémicos",
        family_1: '<p><strong>Con ' + TERMS.katuvys + ':</strong> ' + TERMS.isqun + ' es una de las bandas potenciales internas de la matriz-substrato. Sigue siendo katûvýsica en su naturaleza y participa en la expansión del mundo por regulación y no por dominación.</p>',
        family_2: '<p><strong>Con ' + TERMS.threnisqun + ' y ' + TERMS.enneagone + ':</strong> 492 es su onda común de alineación. ' + TERMS.isqun + ' es la frecuencia de origen, ' + TERMS.threnisqun + ' la frecuencia de experiencia y ' + TERMS.enneagone + ' la estructura operativa interna a ' + TERMS.isqun + ' cuando los nueve Sellos actúan simultáneamente.</p>',
        h_wordbuild: "Construcción del término",
        word_blocks: [
          { head: "1) isqun", text: "Raíz quechua que significa “nueve”: el término porta la lógica de una coherencia vibratoria a nueve centros." },
          { head: "2) –isqun", text: "Sufijo canónico empleado para organizaciones en base nueve como " + canon("Katûvýsqun") + " y " + TERMS.threnisqun + "." },
          { head: "3) Valor operativo", text: "El término nombra una banda de frecuencias potenciales cuya función consiste en equilibrar cíclicamente y preparar silenciosamente la regulación." }
        ],
        word_notes: [
          'Estatuto: entrada canónica epicena e invariable.',
          'Elemento: ' + TERMS.katuvys + '.',
          'Frecuencia de alineación compartida con ' + TERMS.threnisqun + ': 492.',
          TERMS.enneagone + ' es la estructura operativa interna de ' + TERMS.isqun + ', no un sistema exterior ni autónomo.'
        ],
        cta_translate: "Proponer una traducción del concepto"
      };
    }

    return {
      title: "Isqun",
      kicker: 'Extrait de <em>' + TERMS.katupirsia5 + '</em><br />(Bande de fréquences potentielles et structure d’onde porteuse de régulation à neuf pôles)',
      h_def: "Définition opérative",
      meta_html:
        buildMetaCard("Élément", URLS.katuvys_img, TERMS.katuvys, URLS.katuvys) +
        buildMetaCard("Fréquence d’alignement", URLS.freq492, "492 Hz") +
        buildMetaCard("Structure opérative", URLS.enneagone_concept, TERMS.enneagone, URLS.enneagone),
      def_short: TERMS.isqun + ' désigne la bande de fréquences potentielles dans laquelle résident les neuf Sceaux régulateurs ; leur action simultanée à l’intérieur de cette même bande fait apparaître ' + TERMS.enneagone + ' comme sa structure opérative.',
      def_long:
        '<p>' + TERMS.isqun + ' n’est ni une figure décorative, ni un simple champ. C’est un régulateur de fréquences qui ordonne la géométrie du champ sans l’imposer, maintient l’équilibre du souffle posœnnoïal et crée les conditions d’une ' + canon('RéZonans') + ' stable.</p>' +
        '<p>Dans cette bande, les neuf Sceaux existent, vibrent et interagissent. Leur activation simultanée ne crée pas un corps extérieur posé à côté d’' + TERMS.isqun + ' : elle fait apparaître une configuration opérative interne, ' + TERMS.enneagone + ', qui demeure partie intégrante de la bande isqunienne.</p>' +
        '<p>Lorsque l’interaction entre les Sceaux atteint une intensité critique, l’excédent produit ne quitte pas ' + TERMS.katuvys + '. Il change d’état : de fréquences, il devient densités opératives et se condense dans ' + TERMS.threnisqun + '. La même onde d’alignement — 492 — assure la continuité entre origine et expérience.</p>',
      h_config: "Configuration opérative",
      config_html: buildConfigurationCard(lang),
      h_sceaux: "Les neuf Sceaux régulateurs",
      sceaux_html: buildSealCards(lang),
      h_features: "Dynamiques opératives",
      features: [
        TERMS.isqun + ' nomme le plan structurel qui ré-accorde sans appel conscient.',
        'Il ordonne le champ sans l’imposer et rend possible une cohérence vibratoire stable.',
        'Ses neuf pôles agissent comme régulateurs du temps, du déphasage, de la perception, de l’entropie, des affects, de la mémoire, du discursif, de l’émergence et de l’origine.',
        TERMS.enneagone + ' apparaît seulement lorsque les neuf Sceaux entrent en action simultanée et en syntonie complète à l’intérieur d’' + TERMS.isqun + '.',
        TERMS.threnisqun + ' reçoit les résidus opératifs condensés produits par l’interaction intense des Sceaux.'
      ],
      h_questions: "Applications / repères",
      questions: [
        'La situation appelle-t-elle un rééquilibrage structurel silencieux, ou une action rituélique localisée ?',
        'Quel Sceau correspond le mieux à l’excès observé : temps, déphasage, sensorialité, infini, affects, mémoire, discursif, forme ou origine ?',
        'Le problème se tient-il encore au plan de bande (' + TERMS.isqun + ') ou déjà au plan de réponse condensée (' + TERMS.threnisqun + ') ?',
        'Les tensions sont-elles dissoutes, ou seulement accordées dans une géométrie vivable ?'
      ],
      example_title: "Ex.",
      example: 'Quand un champ se sature sans demander encore un rite explicite, ' + TERMS.isqun + ' reste le nom juste. Quand l’excès devient situé et exige une activation précise, l’opération bascule vers ' + TERMS.threnisqun + '.',
      h_family: "Liens systémiques",
      family_1: '<p><strong>Avec ' + TERMS.katuvys + ' :</strong> ' + TERMS.isqun + ' est l’une des bandes potentielles internes de la matrice-substrat. Il demeure katûvýsien dans sa nature et participe à l’expansion du monde par régulation plutôt que par domination.</p>',
      family_2: '<p><strong>Avec ' + TERMS.threnisqun + ' et ' + TERMS.enneagone + ' :</strong> 492 constitue leur onde commune d’alignement. ' + TERMS.isqun + ' est la fréquence d’origine, ' + TERMS.threnisqun + ' la fréquence d’expérience, et ' + TERMS.enneagone + ' la structure opérative interne à ' + TERMS.isqun + ' lorsque les neuf Sceaux agissent simultanément.</p>',
      h_wordbuild: "Construction du terme",
      word_blocks: [
        { head: "1) isqun", text: "Racine quechua signifiant « neuf » : le mot porte la logique d’une cohérence vibratoire à neuf centres." },
        { head: "2) –isqun", text: "Suffixe canonique employé pour des organisations en base neuf comme " + canon("Katûvýsqun") + " et " + TERMS.threnisqun + "." },
        { head: "3) Valeur opérative", text: "Le terme nomme une bande de fréquences potentielles dont la fonction consiste à équilibrer cycliquement et à préparer silencieusement la régulation." }
      ],
      word_notes: [
        'Statut : entrée canonique épicène et invariable.',
        'Élément : ' + TERMS.katuvys + '.',
        'Fréquence d’alignement partagée avec ' + TERMS.threnisqun + ' : 492.',
        TERMS.enneagone + ' est la structure opérative interne à ' + TERMS.isqun + ', non un système extérieur ni autonome.'
      ],
      cta_translate: "Proposer une traduction du concept"
    };
  }

  function getRoots(){ return qsa(document, ROOT_SEL); }

  function applyLang(lang){
    lang = normLang(lang);
    storeLang(lang);

    getRoots().forEach(function(root){
      var F = content(lang);
      setImage(root, "title_img", URLS.title, F.title);
      setSlotText(root, "title", F.title);
      setSlotHTML(root, "kicker", F.kicker);
      setSlotText(root, "h_def", F.h_def);
      setSlotHTML(root, "meta_cluster", F.meta_html);
      setSlotHTML(root, "def_short", F.def_short);
      setSlotHTML(root, "def_long", F.def_long);
      setSlotText(root, "h_config", F.h_config);
      setSlotHTML(root, "config_card", F.config_html);
      setSlotText(root, "h_sceaux", F.h_sceaux);
      setSlotHTML(root, "sceaux_cards", F.sceaux_html);
      setSlotText(root, "h_features", F.h_features);
      setSlotText(root, "hint_fold", {FR:"déplier",EN:"expand",ES:"desplegar"}[lang]);
      renderListInto(root, "features", F.features);
      setSlotText(root, "h_questions", F.h_questions);
      setSlotText(root, "hint_fold2", {FR:"déplier",EN:"expand",ES:"desplegar"}[lang]);
      renderListInto(root, "questions", F.questions);
      setSlotHTML(root, "example_box", '<p><strong>' + F.example_title + '</strong> ' + F.example + '</p>');
      setSlotText(root, "h_family", F.h_family);
      setSlotText(root, "hint_fold3", {FR:"déplier",EN:"expand",ES:"desplegar"}[lang]);
      setSlotHTML(root, "family_1", F.family_1);
      setSlotHTML(root, "family_2", F.family_2);
      setSlotText(root, "h_wordbuild", F.h_wordbuild);
      renderWordBlocks(root, "wordbuild_blocks", F.word_blocks);
      renderListInto(root, "wordbuild_notes", F.word_notes);
      setSlotText(root, "cta_translate", F.cta_translate);

      qsa(root, '.po-langbtn').forEach(function(btn){
        var isActive = btn.getAttribute('data-po-lang') === lang;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      ensureAudioButtons(root, lang);
      refreshAudioButtons(root, lang);
      enforceTranslateNo(root);
    });
  }

  function bindButtons(){
    getRoots().forEach(function(root){
      if (root.__poLangBound) return;
      root.__poLangBound = true;
      qsa(root, '.po-langbtn').forEach(function(btn){
        btn.addEventListener('click', function(){
          applyLang(btn.getAttribute('data-po-lang'));
        });
      });
    });
  }

  function enforceTranslateNo(node){
    if (!node || node.nodeType !== 1) return;
    if (node.classList && node.classList.contains('notranslate') && node.getAttribute('translate') !== 'no') {
      node.setAttribute('translate', 'no');
    }
    qsa(node, '.notranslate').forEach(function(el){
      if (el.getAttribute('translate') !== 'no') el.setAttribute('translate', 'no');
    });
  }

  function keepProtected(){
    getRoots().forEach(function(root){
      enforceTranslateNo(root);
      if (!window.MutationObserver || root.__po_isqun_observer) return;
      root.__po_isqun_observer = true;
      var queued = false;
      var mo = new MutationObserver(function(muts){
        if (queued) return;
        queued = true;
        (window.requestAnimationFrame || window.setTimeout)(function(){
          queued = false;
          muts.forEach(function(mut){
            if (mut.type !== 'childList') return;
            Array.prototype.forEach.call(mut.addedNodes || [], function(added){
              if (!added || added.nodeType !== 1) return;
              enforceTranslateNo(added);
            });
          });
        }, 0);
      });
      mo.observe(root, { childList:true, subtree:true });
    });
  }

  var PO_AUDIO_SYNTH = (typeof window !== 'undefined' && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: ""
  };

  function ensureAudioStyles(){
    if (document.getElementById('po-k5-isqun-audio-styles')) return;
    var style = document.createElement('style');
    style.id = 'po-k5-isqun-audio-styles';
    style.textContent = [
      '.po-axis-audio-wrap{display:flex;justify-content:center;margin:12px 0 14px;}',
      '.po-audio-btn{appearance:none;-webkit-appearance:none;border:1px solid rgba(13,47,31,.22);background:rgba(13,47,31,.03);color:inherit;border-radius:999px;padding:8px 14px;font:inherit;font-size:12px;line-height:1;cursor:pointer;transition:transform .18s ease,box-shadow .18s ease,border-color .18s ease,background .18s ease;}',
      '.po-audio-btn:hover{transform:translateY(-1px);box-shadow:0 8px 18px rgba(13,47,31,.08);border-color:rgba(13,47,31,.34);}',
      '.po-audio-btn.is-active{border-color:rgba(13,47,31,.62);background:rgba(13,47,31,.08);font-weight:700;}',
      '.po-lex-summary .po-audio-btn{margin-left:auto;flex:0 0 auto;}',
      '.po-lex-summary__title{display:inline-flex;align-items:center;gap:10px;}',
      '@media (max-width:700px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-audio-btn{order:3;margin-left:0;}}'
    ].join('');
    document.head.appendChild(style);
  }

  function createAudioButton(role){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'po-audio-btn notranslate';
    btn.setAttribute('translate', 'no');
    btn.setAttribute('data-po-audio-role', role);
    return btn;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var top = qs(root, '.po-axis-top');
    var generalWrap = qs(root, '.po-axis-audio-wrap[data-po-audio-role="general"]');
    if (!generalWrap && top){
      generalWrap = document.createElement('div');
      generalWrap.className = 'po-axis-audio-wrap notranslate';
      generalWrap.setAttribute('translate', 'no');
      generalWrap.setAttribute('data-po-audio-role', 'general');
      generalWrap.appendChild(createAudioButton('general'));
      var langbar = qs(root, '.po-langbar');
      if (langbar && langbar.parentNode === top){
        if (langbar.nextSibling) top.insertBefore(generalWrap, langbar.nextSibling);
        else top.appendChild(generalWrap);
      } else {
        top.appendChild(generalWrap);
      }
    }

    qsa(root, '.po-lex-details').forEach(function(details, idx){
      var summary = qs(details, '.po-lex-summary');
      if (!summary) return;
      var btn = qs(summary, '.po-audio-btn[data-po-audio-role="block"]');
      if (!btn){
        btn = createAudioButton('block');
        btn.setAttribute('data-po-audio-index', String(idx));
        summary.appendChild(btn);
      }
    });

    bindAudioButtons(root, lang);
  }

  function refreshAudioButtons(root, lang){
    var ui = audioUI(lang);
    qsa(root, '.po-audio-btn').forEach(function(btn){
      var role = btn.getAttribute('data-po-audio-role');
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === (role === 'general' ? 'general' : ('block:' + (btn.getAttribute('data-po-audio-index') || '0'))));
      btn.textContent = active ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.classList.toggle('is-active', !!active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function bindAudioButtons(root, lang){
    qsa(root, '.po-audio-btn').forEach(function(btn){
      if (btn.__poAudioBound) return;
      btn.__poAudioBound = true;
      btn.addEventListener('click', function(ev){
        ev.preventDefault();
        ev.stopPropagation();
        var role = btn.getAttribute('data-po-audio-role');
        var key = role === 'general' ? 'general' : ('block:' + (btn.getAttribute('data-po-audio-index') || '0'));
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === key){
          stopAudio();
          refreshAudioButtons(root, readLang());
          return;
        }
        startAudio(root, readLang(), key);
      });
    });
  }

  function textFromNode(node){
    if (!node) return '';
    var clone = node.cloneNode(true);
    qsa(clone, 'script,style,.po-audio-btn').forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var txt = (clone.innerText || clone.textContent || '')
      .replace(/\s+/g, ' ')
      .replace(/\s([:;!?])/g, '$1')
      .trim();
    return txt;
  }

  function buildIntroText(root){
    var parts = [];
    ['title','kicker','h_def','meta_cluster','def_short','def_long','h_config','config_card','h_sceaux','sceaux_cards'].forEach(function(slot){
      var node = qs(root, '[data-po-slot="' + slot + '"]');
      var txt = textFromNode(node);
      if (txt) parts.push(txt);
    });
    return parts.join('. ');
  }

  function buildBlockText(details){
    if (!details) return '';
    var parts = [];
    var summary = qs(details, '.po-lex-summary');
    if (summary){
      var title = textFromNode(qs(summary, '.po-lex-summary__title'));
      if (title) parts.push(title);
    }
    var clone = details.cloneNode(true);
    clone.open = true;
    qsa(clone, '.po-audio-btn,.po-lex-summary__hint').forEach(function(el){
      if (el && el.parentNode) el.parentNode.removeChild(el);
    });
    var txt = textFromNode(clone);
    if (txt) parts.push(txt);
    return parts.join('. ');
  }

  function splitTextForSpeech(text){
    var raw = clampStr(text).replace(/\s+/g, ' ').trim();
    if (!raw) return [];
    var sentences = raw.match(/[^.!?]+[.!?…]?/g) || [raw];
    var chunks = [];
    var current = '';
    sentences.forEach(function(sentence){
      var s = sentence.trim();
      if (!s) return;
      if (!current){
        current = s;
        return;
      }
      if ((current + ' ' + s).length <= 210){
        current += ' ' + s;
      } else {
        chunks.push(current);
        current = s;
      }
    });
    if (current) chunks.push(current);
    return chunks;
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    var targets = lang === 'EN' ? ['en'] : (lang === 'ES' ? ['es'] : ['fr']);
    for (var i=0;i<voices.length;i++){
      var vlang = clampStr(voices[i].lang).toLowerCase();
      for (var j=0;j<targets.length;j++){
        if (vlang.indexOf(targets[j]) === 0) return voices[i];
      }
    }
    return voices[0] || null;
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch(e){}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = '';
    getRoots().forEach(function(root){ refreshAudioButtons(root, readLang()); });
  }

  function speakNextChunk(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.chunks.length) {
      speakNextUnit(lang);
      return;
    }
    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      speakNextUnit(lang);
      return;
    }
    var utter = new SpeechSynthesisUtterance(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    var voice = pickVoice(lang);
    if (voice) utter.voice = voice;
    utter.lang = lang === 'EN' ? 'en-US' : (lang === 'ES' ? 'es-ES' : 'fr-FR');
    utter.onend = function(){ speakNextChunk(lang); };
    utter.onerror = function(){ speakNextChunk(lang); };
    try { PO_AUDIO_SYNTH.speak(utter); } catch(e){ speakNextChunk(lang); }
  }

  function speakNextUnit(lang){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    if (unit.node && unit.node.tagName && unit.node.tagName.toLowerCase() === 'details'){
      unit.node.open = true;
    }
    PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text);
    PO_AUDIO_STATE.chunkPos = -1;
    speakNextChunk(lang);
  }

  function buildUnits(root, key){
    var units = [];
    if (key === 'general'){
      var intro = buildIntroText(root);
      if (intro) units.push({ key:'general', node: root, text: intro });
      qsa(root, '.po-lex-details').forEach(function(details, idx){
        var txt = buildBlockText(details);
        if (txt) units.push({ key:'block:' + idx, node: details, text: txt });
      });
      return units;
    }
    var idx = parseInt(String(key).split(':')[1], 10);
    if (isNaN(idx)) idx = 0;
    qsa(root, '.po-lex-details').forEach(function(details, pos){
      if (pos < idx) return;
      var txt = buildBlockText(details);
      if (txt) units.push({ key:'block:' + pos, node: details, text: txt });
    });
    return units;
  }

  function startAudio(root, lang, key){
    if (!PO_AUDIO_SYNTH){
      refreshAudioButtons(root, lang);
      return;
    }
    try { PO_AUDIO_SYNTH.cancel(); } catch(e){}
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildUnits(root, key);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = key;
    refreshAudioButtons(root, lang);
    if (!PO_AUDIO_STATE.units.length){
      stopAudio();
      return;
    }
    speakNextUnit(lang);
  }

  if (PO_AUDIO_SYNTH && PO_AUDIO_SYNTH.onvoiceschanged !== undefined) {
    PO_AUDIO_SYNTH.onvoiceschanged = function(){ getRoots().forEach(function(root){ refreshAudioButtons(root, readLang()); }); };
  }

  function init(){
    bindButtons();
    applyLang(readLang());
    keepProtected();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.PoK5IsqunTextsFR_EN_ES_20260305 = {
    init: init,
    setLang: applyLang,
    getLang: readLang,
    normLang: normLang,
    stopAudio: stopAudio
  };
})();
